module.exports = __webpack_public_path__ + "img/icon-lock.089f7dd1.svg";